import { pushToDataLayer, DataLayerEvent } from 'components/helpers/Global/Analytics/DataLayer';
import { SearchRecord } from 'lib/services/models/search-response';
import { Item } from '@sitecore-content-sdk/nextjs';

export type ContentGridContentResultAnalyticsTrigger = 'always' | 'related-content';

export interface ContentGridContentResultAnalyticsConfig {
  contentListName: string;
  trigger?: ContentGridContentResultAnalyticsTrigger;
}

export const RELATED_CONTENT_ANALYTICS_CONFIG: ContentGridContentResultAnalyticsConfig = {
  contentListName: 'RelatedContent',
  trigger: 'related-content',
};

export const isContentGridContentResultEnabled = ({
  analyticsConfig,
}: {
  analyticsConfig?: ContentGridContentResultAnalyticsConfig;
}) => {
  return !!analyticsConfig;
};

export const buildContentGridContentResultAnalyticsConfig = (
  contentList?: Item,
  heading?: string
): ContentGridContentResultAnalyticsConfig | undefined => {
  if (!contentList) {
    return undefined;
  }

  const preferredHeading = heading?.trim();
  const contentListName = preferredHeading || contentList.name || 'ContentList';

  return {
    contentListName,
    trigger: 'always',
  };
};

export const pushContentGridContentResultEvent = ({
  analyticsConfig,
  card,
  contentTitle,
  currentPageType,
  language,
}: {
  analyticsConfig: ContentGridContentResultAnalyticsConfig;
  card: SearchRecord;
  contentTitle: string;
  currentPageType?: string;
  language?: string;
}) => {
  const payload: DataLayerEvent = {
    event: 'content_result',
    content_list_name: analyticsConfig.contentListName,
    current_page_type: currentPageType || '',
    language: (language || '').toLowerCase(),
    content_id: card.ContentId || '',
    content_title: contentTitle || '',
    content_type: card.ContentType || '',
  };
  pushToDataLayer(payload);
};
